import { Component } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Select } from '../../../../forms/select/index';
import { PhoneNumberOption } from './PhoneNumberOption';
import styles from './SelectPhoneNumber.module.css';
import messages from './SelectPhoneNumber.messages';
import { TDeserialisedPerson } from '../OnfidoVerificationModal.types';

export class SelectPhoneNumber extends Component<{
    name: string;
    disabled?: boolean;
    addNewNumber: () => void;
    options: TDeserialisedPerson['phones'];
}> {
    handleOnSelectChange = (
        value: { type: string; value: string },
        input: { onChange: (value: string) => void }
    ) => {
        if (value.type === 'ADD_NEW') {
            this.props.addNewNumber();
        } else {
            input.onChange(value.value);
        }
    };

    render() {
        const { name, disabled, addNewNumber } = this.props;

        return (
            <Select
                className={classNames(styles.SelectPhoneNumber, 'fs-exclude')}
                placeholder={<FormattedMessage {...messages.select} />}
                name={name}
                disabled={disabled}
                addNewNumber={addNewNumber}
                selectOptions={{
                    classNameSelect: styles.SelectPaymentMethodDropDown,
                    optionComponent: PhoneNumberOption,
                    onSelect: this.handleOnSelectChange,
                    ...this.props
                }}
            />
        );
    }
}
